import { useHistory, } from 'react-router-dom';
import queryString, { StringifyOptions, } from 'query-string';
import { ProductsFilterStore, } from 'store/ducks/products/collection/types';

export const useUpdateFilterSearchParams = () => {
    const history = useHistory();

    return (params: ProductsFilterStore['filters'], queryStringOptions: StringifyOptions = { arrayFormat: 'comma', }) => {
        const search = queryString.stringify(params, queryStringOptions);

        history.push({ search, });
    };
};
